/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Review_Annotations_WarningInputs */

const en_review_annotations_warning = /** @type {(inputs: Review_Annotations_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the PDF with Adobe Acrobat to get the full experience`)
};

const de_review_annotations_warning = /** @type {(inputs: Review_Annotations_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Adobe Acrobat öffnen für die komplette Erfahrung`)
};

/**
* | output |
* | --- |
* | "Open the PDF with Adobe Acrobat to get the full experience" |
*
* @param {Review_Annotations_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const review_annotations_warning = /** @type {((inputs?: Review_Annotations_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_Annotations_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_review_annotations_warning(inputs)
	return en_review_annotations_warning(inputs)
});